module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/pdp_paperNatural-cfff24b7ff46dcacafc72a047e9eeeae.jpg";